






































































































































































































import { Component } from "vue-property-decorator";
import axios from "axios";
import HacoBase from "../HacoBase";

@Component
export default class DiecutEditComp extends HacoBase {
  editData: any = {};
  $debugServer!: string;
  costTypeA = true;
  costTypeB = false;
  defData: any = {};

  mounted(): void {
    let editId: number;
    if (this.$route.params.id === undefined) {
      return;
    } else {
      editId = parseInt(this.$route.params.id, 10);
      this.defData = {
        id: editId,
        itemDieCutName: "",
        costType: "manual",
        machineRunningMinCost: null,
        machineDieCutCosts: [
          {
            itemDieCutId: this.$route.params.id,
            sheetFrom: 0,
            sheetTo: -1,
            cost: 1
          }
        ],
        manualDieCutCosts: {
          costPerHour: 0,
          preparationTimePerMin: 0,
          sheetPerHour: 0
        }
      };

      let url = this.$debugServer + "/api/v1_inner/diecut/";
      let accessMethod = "post";
      /** 新規の場合 */
      if (editId === -1) {
        this.costTypeA = true;
        this.costTypeB = false;
        this.editData = {
          dieCut: this.defData
        };
        return;
      } else {
        url += this.$route.params.id + "/edit";
        accessMethod = "get";
      }
      const params: object = this.setAxiosParams(url, accessMethod);

      axios(params)
        .then((response: any): void => {
          this.editData = response.data;
          if (this.editData.dieCut.costType === "manual") {
            this.costTypeA = true;
            this.costTypeB = false;
          } else {
            this.costTypeA = false;
            this.costTypeB = true;
          }
        })
        .catch((error: any): void => {
          console.log("[mount error]", error.response);
          this.toLoginPage(error);
        });
    }
  }

  checkInputKeys(e: KeyboardEvent): void {
    if (e.ctrlKey === true && e.key === "Enter") {
      this.onSubmit();
    }
  }

  onSubmit(back = false): void {
    const mes = this.$t("message.editCommon.saveConfirmation");
    const confirmation: boolean = confirm(mes as string);
    if (confirmation === false) {
      return;
    }
    const editData: any = this.editData;
    const bool: boolean = this.resetSheetFromEle();
    if (bool === true) {
      return;
    }

    if (this.editData.dieCut.costType === "machine") {
      const sheetValueCheck: number[] = this.checkSheetValue(
        editData.dieCut.machineDieCutCosts
      );

      /** sheetFromおかしかったらエラー出す */
      if (sheetValueCheck[1] !== -1) {
        this.showSheetFromError(sheetValueCheck);
        return;
      }
      /** itemDieCutId統一(新規継続対策) */
      for (const item of editData.dieCut.machineDieCutCosts) {
        item.itemDieCutId = editData.dieCut.id;
      }
      /** 問題なかったらsheetToの値を設定 */
      this.setSheetTo(editData.dieCut.machineDieCutCosts);
      console.log("[fixed editData]", editData);
      editData.dieCut.manualDieCutCosts = null;
    } else {
      editData.dieCut.machineRunningMinCost = null;
      editData.dieCut.machineDieCutCosts.length = 0;
    }

    /** 表記の揺れ対策 */
    interface CategoryObj {
      category: string;
      backTo: string;
      dataName: string;
    }
    const categoryObj: CategoryObj = {
      category: "diecut",
      backTo: "Diecut",
      dataName: "dieCut"
    };
    const id: number = parseInt(editData.dieCut.id, 10);
    this.sendEditData(id, editData, categoryObj, back, this.afterSaving);
  }

  afterSaving(): void {
    void 0;
  }

  /** コストタイプ変更 */
  changeCostType(costType: string): void {
    const data: any = this.editData.dieCut;
    data.costType = costType;
    this.editData.dieCut.costType = costType;
    /** 初期値を設定する  */
    if (costType === "machine") {
      if (this.editData.dieCut.machineDieCutCosts.length === 0) {
        this.editData.dieCut.machineDieCutCosts = Object.assign(
          [],
          this.defData.machineDieCutCosts
        );
      }
    } else {
      if (this.editData.dieCut.manualDieCutCosts === null) {
        this.editData.dieCut.manualDieCutCosts = Object.assign(
          {},
          this.defData.manualDieCutCosts
        );
      }
    }
  }
}
